import axios from 'axios'
import jwtToken from './getJwtToken'
import { errorHandler } from './errorHandler'

const SALES_SPLITS_URL = process.env.VUE_APP_SALES_SPLITS_URL

const salesSplitsApi = axios.create({
  baseURL: `${SALES_SPLITS_URL}/api/me`,
  headers: {
    Authorization: `Bearer ${jwtToken}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

salesSplitsApi.interceptors.response.use(
  response => response,
  error => errorHandler(error),
)

salesSplitsApi.interceptors.request.use(
  request => request,
  error => errorHandler(error),
)

export default salesSplitsApi
